import { render, staticRenderFns } from "./CarrierCreateOrderButton.vue?vue&type=template&id=28b778d8&scoped=true&"
import script from "./CarrierCreateOrderButton.vue?vue&type=script&lang=js&"
export * from "./CarrierCreateOrderButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b778d8",
  null
  
)

export default component.exports